export default __webpack_public_path__ + "static/aws-box-c1a395a5b9a3deaf3a4267665a021318.svg";